import { render, staticRenderFns } from "./callback-install-orders.vue?vue&type=template&id=1706d36f&scoped=true"
import script from "./callback-install-orders.vue?vue&type=script&lang=js"
export * from "./callback-install-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706d36f",
  null
  
)

export default component.exports